export class ButtonInfo
{
  _id:string;
  get id(){ return this._id;}

  static create( id:string )
  {
    let info = new ButtonInfo();
    info._id = id;
    return info;
  }

  _pressed:boolean = false;
  _pressedBefore:boolean = false;
  _pressedNext:boolean = false;

  get hasChanged(){ return this._pressed != this._pressedBefore };
  get isDown(){ return this.hasChanged && this._pressed; }
  get isUp(){ return this.hasChanged && ! this._pressed; }
  get isHold(){ return this._pressed; }
  

  setNext( state:boolean )
  {
    this._pressedNext = state;
  }

  update()
  {
    this._pressedBefore = this._pressed;
    this._pressed = this._pressedNext;
  }
}